<template>
  <div id="login">
    <section class="bannerprincipal pb-2">
      <SiteNav></SiteNav>
      <div
        class="col-12 text-center py-3"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <div class="row"></div>
      </div>
    </section>

    <div class="text-center mt-5 py-5" data-aos="fade-up" data-aos-delay="600">
      <p class="fXG py-5 amarillo">&nbsp;</p>
    </div>

    <div class="container-fluid bgblanco py-3">
      <!-- <div class="row pb-5">
        <div class="col-12 blockd fG amarillo">Semana 1</div>
      </div>-->

      <b-tabs content-class="mt-3 row">
        <b-tab title="Registros" active @click="getRegistros()">
          <div class="">
            <div class="col-12">
              <table border="0" cellspacing="0" cellpadding="0" width="876">
                <tbody>
                  <tr>
                    <td width="111"></td>
                    <td width="165">
                      <p align="center">Tope de registros</p>
                    </td>
                    <td width="165">
                      <p align="center">Registros en BD</p>
                    </td>
                    <td width="165">
                      <p align="center">Asistirán</p>
                    </td>
                    <td width="165">
                      <p align="center">NO Asistirán</p>
                    </td>
                    <td width="165">
                      <p align="center">Pendientes</p>
                    </td>
                    <td width="165">
                      <p align="center">Asistiendo</p>
                    </td>
                  </tr>
                  <tr>
                    <td width="111">
                      <p>
                        <strong>Clientes Total</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ tope_clientes_todos }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_todos }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_todos_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_todos_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_todos_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_todos_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="111">
                      <p align="center">
                        <strong>&nbsp;</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p class="small">
                        <strong>Clientes</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td width="111">
                      <p align="center">
                        <strong>&nbsp;</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p class="small">
                        <strong>Clientes TOP</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_top }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_top_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_top_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_top_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_top_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td width="111">
                      <p align="center">
                        <strong>&nbsp;</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p class="small">
                        <strong>Clientes VIP</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_vip }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_vip_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_vip_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_vip_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_vip_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="111">
                      <p>
                        <strong>Equipo Prosa</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ tope_equipo_prosa }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ equipo_prosa }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ equipo_prosa_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ equipo_prosa_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ equipo_prosa_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ equipo_prosa_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="111">
                      <p>
                        <strong>Staff Comm&amp;RP</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ tope_staff_rp }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ staff_rp }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ staff_rp_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ staff_rp_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ staff_rp_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ staff_rp_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="111">
                      <p>
                        <strong>Patrocinios</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ tope_patrocinios }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ patrocinios }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ patrocinios_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ patrocinios_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ patrocinios_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ patrocinios_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="111">
                      <p>
                        <strong>Medios</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ tope_medios }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ medios }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ medios_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ medios_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ medios_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ medios_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="111">
                      <p>
                        <strong>Ponentes</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ tope_ponentes }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ ponentes }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ ponentes_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ ponentes_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ ponentes_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ ponentes_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="111">
                      <p>
                        <strong>Staff Agencias</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ tope_staff_agencias }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ staff_agencias }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ staff_agencias_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ staff_agencias_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ staff_agencias_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ staff_agencias_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="111">
                      <p>
                        <strong>Invitados</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ tope_acompanantes }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ acompanantes }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ acompanantes_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ acompanantes_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ acompanantes_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ acompanantes_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>
                  
                  <tr>
                    <td width="111">
                      <p>
                        <strong>Edecanes</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ tope_edecanes }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ edecanes }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ edecanes_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ edecanes_no }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ edecanes_pendiente }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ edecanes_asistiendo }}</strong>
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td width="111">
                      <p>
                        <strong>TOTALES</strong>
                      </p>
                    </td>
                    <td width="165">
                      <strong>{{ tope_clientes_todos + tope_equipo_prosa + tope_staff_rp + tope_patrocinios + tope_medios + tope_ponentes + tope_staff_agencias + tope_acompanantes + tope_edecanes }}</strong>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes + clientes_top + clientes_vip + equipo_prosa + staff_rp + patrocinios + medios + ponentes + staff_agencias + acompanantes + edecanes }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_si + clientes_top_si + clientes_vip_si + equipo_prosa_si + staff_rp_si + patrocinios_si + medios_si + ponentes_si + staff_agencias_si + acompanantes_si + edecanes_si }}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_no + equipo_prosa_no + staff_rp_no + patrocinios_no + medios_no + ponentes_no + staff_agencias_no + acompanantes_no + edecanes_no}}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_pendiente + equipo_prosa_pendiente + staff_rp_pendiente + patrocinios_pendiente + medios_pendiente + ponentes_pendiente + staff_agencias_pendiente + acompanantes_pendiente + edecanes_pendiente}}</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ clientes_asistiendo + equipo_prosa_asistiendo + staff_rp_asistiendo + patrocinios_asistiendo + medios_asistiendo + ponentes_asistiendo + staff_agencias_asistiendo + acompanantes_asistiendo + edecanes_asistiendo}}</strong>
                      </p>
                    </td>
                  </tr>
                 


                  

                </tbody>
              </table>

              <table border="0" cellspacing="0" cellpadding="0" width="876" style="margin-top:40px;">
                <tbody>
                  <tr>
                    <td width="111">
                      <p>
                        <strong>Sin clasificar / pendientes por aprobar</strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong></strong>
                      </p>
                    </td>
                    <td width="165">
                      <p align="center">
                        <strong>{{ sin_clasificar }}</strong>
                      </p>
                    </td>
                    
                  </tr>



                  <!-- <tr >
                    <td width="111" style="margin-top:30px;">
                      <p>
                        <strong>No. de asistentes en el evento:</strong>
                      </p>
                    </td>
                    <td width="165" style="margin-top:30px;">
                      <p align="center">
                        <strong></strong>
                      </p>
                    </td>
                    <td width="165" style="margin-top:30px;">
                      <p align="center">
                        <strong>{{ no_asistentes }}</strong>
                      </p>
                    </td>
                    
                  </tr> -->

              </tbody>
              </table>

            </div>
            <div class="col-12 negro pt-5 pb-3">
              <span class="fG">Registros</span>
              (Total: {{ registros.length }})
            </div>


            <div class="col-12 negro pb-3">
              <span class="fG">Filtrar por Asistencia al Evento:</span>
            </div>

            <div class="col-6 negro pb-3">
              <select @change="filtrarAsistencia($event)" class="form-control" v-model="filtro_asistencia">
                <option value="">Filtrar por asistencia al evento</option>
                <option value="SI">SI</option>
                <option value="NO">NO</option>
                <option value="PENDIENTE">PENDIENTE</option>
                <option value="ACCESO DENEGADO">ACCESO DENEGADO</option>
              </select>
            </div>



            <div class="col-12" v-if="user.nombre == 'Admin'">
              <download-excel
                class="d-inline-block"
                :data="this.registros"
                name="Registros.xls"
              >
                <button class="btn btn-danger">Exportar Registros</button>
              </download-excel>
            </div>
            <div class="col-12">
              <v-client-table
                class=""
                :columns="columnsRegistros"
                v-model="registros"
                :options="options"
              >
                <a
                  slot="uri"
                  slot-scope="props"
                  target="_blank"
                  :href="props.row.uri"
                  class="glyphicon glyphicon-eye-open"
                  >Ver</a
                >

                <div slot="child_row" slot-scope="props" class="">
                  <div class="row pb-3">
                    <div
                      class="col-12 px-3 pb-3 text-left"
                      v-if="user.nombre == 'Admin'"
                    >
                      <!-- <p class="bold float-left">Editar Datos del Asistente</p> -->
                      <router-link
                        :to="'/administrador/edicion-registro/' + props.row.id"
                        class="btnaction d-inline-block float-left"
                      >
                        <span class="">Editar Datos Personales</span>
                      </router-link>
                    </div>

                    <div class="px-3 pb-3 col-12 text-left">
                      <p class="bold">Asistencia al EVENTO</p>
                      <div class="row">
                        <div class="col-6">
                          <p>
                            <select
                              class="form-control negro"
                              name=""
                              id=""
                              v-model="props.row.asistira_al_evento"
                            >
                              <option value="" hidden>
                                Asistencia al EVENTO
                              </option>
                              <option value="NO">NO</option>
                              <option value="SI">SI</option>
                              <option
                                v-if="user.nombre == 'Admin'"
                                value="PENDIENTE"
                              >
                                PENDIENTE
                              </option>
                              <option
                                v-if="user.nombre == 'Admin'"
                                value="ACCESO DENEGADO"
                              >
                              ACCESO DENEGADO
                              </option>
                            </select>
                          </p>
                        </div>
                        <div class="col-6">
                          <p>
                            <button
                              class="btnaction"
                              @click="
                                changeStatusAsistenciaEvento(
                                  props.row.nombre,
                                  props.row.email,
                                  props.row.codigo_qr,
                                  props.row.asistira_al_evento
                                )
                              "
                            >
                              <span class="">Actualizar</span>
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="px-3 pb-3 col-12 text-left">
                      <div class="row">
                        <div class="col-12">
                          <p>
                            <button
                              class="btnaction"
                              @click="reenviarInvitacionQR(props.row.id)"
                            >
                              <span class="">Reenviar Código QR</span>
                            </button>
                          </p>
                        </div>
                        <div class="col-12">
                          <div class="codigoqradmin">
                            <div>
                              <img
                                :src="
                                  'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=' +
                                  props.row.codigo_qr
                                "
                                width="60%"
                                border="0"
                                alt=""
                                align="center"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-12 pt-2">
                          <p>
                            <a
                              class="btnaction"
                              target="_blank"
                              :href="
                                'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=' +
                                props.row.codigo_qr
                              "
                            >
                              <span class="">Descarga Código QR</span>
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="">
                    <div class="row pb-3">
                      <div class="px-3 pb-3 col-12 text-left">
                        <p class="bold">Tipo de registro</p>
                        <div class="row">
                          <div class="col-6">
                            <p>
                              <select
                                class="form-control negro"
                                name=""
                                id=""
                                v-model="props.row.tipo"
                              >
                                <option value="">Vacío</option>
                                <option value="CLIENTE">CLIENTE</option>
                                <option value="CLIENTE TOP">CLIENTE TOP</option>
                                <option value="CLIENTE VIP">CLIENTE VIP</option>
                                <!-- <option value="SOCIO ESTRATEGICO">
                                  SOCIO ESTRATEGICO
                                </option> -->
                                <option value="EQUIPO PROSA">
                                  EQUIPO PROSA
                                </option>
                                <option value="STAFF COMM & RP">
                                  STAFF COMM & RP
                                </option>
                                <option value="EDECANES">
                                  EDECANES
                                </option>
                                <option value="PATROCINIOS">PATROCINIOS</option>
                                <option value="MEDIOS">MEDIOS</option>
                                <option value="PONENTE">PONENTE</option>
                                <option value="STAFF AGENCIAS">
                                  STAFF AGENCIAS
                                </option>
                                <option value="INVITADO">
                                  INVITADO
                                </option>
                                <!-- <option value="Talks 2 Code">
                                  Talks 2 Code
                                </option> -->
                              </select>
                            </p>
                          </div>
                          <div class="col-6">
                            <p>
                              <button
                                class="btnaction"
                                @click="
                                  changeStatusTipoRegistro(
                                    props.row.id,
                                    props.row.email,
                                    props.row.tipo
                                  )
                                "
                              >
                                <span class="">Actualizar</span>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="row pb-3">
                    <div class="col-12 px-3 pb-3 text-left">
                      
                      <button
                        @click="
                          cancelarRegistro(
                            props.row.id,
                            props.row.nombre,
                            props.row.apellido_paterno
                          )
                        "
                        class="btnaction d-inline-block float-left"
                      >
                        <span class="">Cancelar Registro</span>
                      </button>
                    </div>
                  </div> -->
                </div>
              </v-client-table>
            </div>
          </div>
        </b-tab>
        <b-tab title="Registro de Asistentes" v-if="user.nombre == 'Admin'">
          <div class>
            <div class="pt-4 fG col-12">
              Se le enviará <b>QR y código de entrada</b> por correo al
              asistente al terminar el registro.
            </div>

            <div class="col-12 col-lg-6 pt-5">
              <form @submit="signup($event)" class="r15">
                <div class="col-12 text-left pt-1 pt-md-0 pb-4 mt-n4">
                  <p class="fXG2 pb-2 morado bold">Registro</p>
                  <p class="negro fG2">Llena los siguientes campos:</p>
                </div>
                <div class="col-12">
                  <div class="row pb-4">
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Nombre</div> -->
                      <input
                        v-model.trim="signupForm.nombre"
                        type="text"
                        placeholder="Nombre(s)*"
                        @input="
                          signupForm.nombre = $event.target.value.toUpperCase();
                          signupForm.nombre = quitarAcentos(signupForm.nombre);
                        "
                        required
                      />
                    </div>

                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Nombre</div> -->
                      <input
                        v-model.trim="signupForm.nombre_2"
                        type="text"
                        placeholder="Segundo nombre"
                        @input="
                          signupForm.nombre_2 =
                            $event.target.value.toUpperCase();
                          signupForm.nombre_2 = quitarAcentos(
                            signupForm.nombre_2
                          );
                        "
                      />
                    </div>

                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.apellido_paterno"
                        type="text"
                        placeholder="Apellido Paterno*"
                        @input="
                          signupForm.apellido_paterno =
                            $event.target.value.toUpperCase();
                          signupForm.apellido_paterno = quitarAcentos(
                            signupForm.apellido_paterno
                          );
                        "
                      />
                    </div>
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.apellido_materno"
                        type="text"
                        placeholder="Apellido Materno*"
                        @input="
                          signupForm.apellido_materno =
                            $event.target.value.toUpperCase();
                          signupForm.apellido_materno = quitarAcentos(
                            signupForm.apellido_materno
                          );
                        "
                      />
                    </div>
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.empresa"
                        type="text"
                        placeholder="Empresa*"
                        @input="
                          signupForm.empresa =
                            $event.target.value.toUpperCase();
                          signupForm.empresa = quitarAcentos(
                            signupForm.empresa
                          );
                        "
                        required
                      />
                    </div>
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.puesto"
                        type="text"
                        placeholder="Puesto*"
                        @input="
                          signupForm.puesto = $event.target.value.toUpperCase();
                          signupForm.puesto = quitarAcentos(signupForm.puesto);
                        "
                        required
                      />
                    </div>
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.email_user"
                        type="email"
                        placeholder="Correo Electrónico*"
                        @input="
                          signupForm.email_user =
                            $event.target.value.toLowerCase();
                          signupForm.email_user = quitarAcentos(
                            signupForm.email_user
                          );
                        "
                        required
                      />
                    </div>
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-9 pb-0">
                          <!-- <div class="blanco fG">Correo Electrónico</div> -->
                          <!-- <select v-model="signupForm.codigo_pais" required>
                          <option value="">Código País</option>

                          <option value="+52">MÉXICO +52</option>
                          <option value="+1">ESTADOS UNIDOS +1</option>
                          <option value="+1">CANADÁ +1</option>
                          <option value="+55">BRASIL +55</option>
                        </select> -->
                          <input
                            v-model.trim="signupForm.telefono"
                            type="number"
                            placeholder="Teléfono"
                            maxlength="10"
                          />
                        </div>

                        <div class="col-3 pb-0">
                          <input
                            v-model.trim="signupForm.ext"
                            type="number"
                            placeholder="Ext."
                            maxlength="10"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.movil"
                        type="number"
                        placeholder="Celular*"
                        maxlength="10"
                        required
                      />
                      <p class="negro">
                        <b>IMPORTANTE:</b> En este número de celular el
                        asistente recibirá notificaciones en tiempo real durante
                        el evento.
                      </p>
                    </div>
                  </div>

                  <div class="row pb-5">
                    <div class="col-12 text-center">
                      <button
                        type="submit"
                        class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                      >
                        Registrar
                      </button>
                    </div>
                  </div>
                </div>
                <!-- <div class="extras text-center">
                    <a @click="toggleForm()" class="pointer"
                      >Regresar al Login</a
                    >
                  </div> -->
              </form>
            </div>
          </div>
        </b-tab>

        <b-tab title="Invitados" @click="getInvitados()">
          <div class>
            <div class="col-12 negro pt-5 pb-3">
              <span class="blockd fG">Invitados</span>
              (Total: {{ invitados.length }})
            </div>

            <div class="col-12 negro pb-3">
              <span class="fG">Filtrar por Asistencia al Evento:</span>
            </div>

            <div class="col-6 negro pb-3">
              <select @change="filtrarAsistenciaInvitados($event)" class="form-control" v-model="filtro_asistencia_invitados">
                <option value="">Filtrar por asistencia al evento</option>
                <option value="SI">SI</option>
                <option value="NO">NO</option>
                <option value="VALIDO">VALIDO</option>
                
              </select>
            </div>

            <div class="col-12" v-if="user.nombre == 'Admin'">
              <download-excel
                class="d-inline-block"
                :data="this.invitados"
                name="Invitados"
              >
                <button class="btn btn-danger">Exportar invitados</button>
              </download-excel>
            </div>
            <div class="col-12">
              <v-client-table
                class=""
                :columns="columnsInvitados"
                v-model="invitados"
                :options="options"
              >
                <div slot="child_row" slot-scope="props" class="">
                  <div
                    class="row pb-3"
                    v-if="
                      user.nombre == 'Admin' &&
                      props.row.status == 'POR VALIDAR'
                    "
                  >
                    <div class="col-12 px-3 pb-3 text-left">
                      <!-- <p class="bold float-left">Editar Datos del Asistente</p> -->
                      <button
                        @click="validarInvitacion(props.row.email)"
                        class="btnaction d-inline-block float-left"
                      >
                        <span class="">Validar invitación y enviar</span>
                      </button>
                    </div>
                  </div>

                  <div class="row pb-3" v-if="props.row.status == 'VALIDO'">
                    <div class="col-12 px-3 pb-3 text-left">
                      <!-- <p class="bold float-left">Editar Datos del Asistente</p> -->
                      <button
                        @click="reenviarInvitacion(props.row.email)"
                        class="btnaction d-inline-block float-left"
                      >
                        <span class="">Reenviar Invitación</span>
                      </button>
                    </div>
                  </div>

                  <div class="row pb-3">
                    <!-- <div class="col-12 px-3 pb-3 text-left">
                      
                      <button
                        @click="
                          cancelarInvitacion(
                            props.row.email,
                            props.row.nombre_1,
                            props.row.apellido_paterno
                          )
                        "
                        class="btnaction d-inline-block float-left"
                      >
                        <span class="">No asistirá</span>
                      </button>
                    </div> -->

                    <div class="px-3 pb-3 col-12 text-left">
                      <p class="bold">Asistencia al EVENTO</p>
                      <div class="row">
                        <div class="col-6">
                          <p>
                            <select
                              class="form-control negro"
                              name=""
                              id=""
                              v-model="props.row.status"
                            >
                              <option value="" hidden>
                                Asistencia al EVENTO
                              </option>
                              <option value="NO">NO</option>
                              <option value="SI">SI</option>
                              <option
                                v-if="user.nombre == 'Admin'"
                                value="VALIDO"
                              >
                                VALIDO
                              </option>
                            </select>
                          </p>
                        </div>
                        <div class="col-6">
                          <p>
                            <button
                              class="btnaction"
                              @click="
                                cancelarInvitacion(
                                  props.row.email,
                                  props.row.nombre_1,
                                  props.row.apellido_paterno,
                                  props.row.status
                                )
                              "
                            >
                              <span class="">Actualizar</span>
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-client-table>
            </div>
          </div>
        </b-tab>

        <b-tab title="Alta de Invitados" @click="getInvitados()">
          <div class="">
            <div class="pt-4 fG col-12">
              Se le enviará <b>invitación</b> por correo al contacto al terminar
              el registro.
            </div>
            <div class="col-12 col-lg-6 pt-5">
              <form @submit="signupInvitado($event)" class="r15">
                <div class="col-12 text-left pt-1 pt-md-0 pb-4 mt-n4">
                  <p class="fXG pb-2 morado bold">Alta de invitado</p>
                  <p class="negro fG2">Llena los siguientes campos:</p>
                </div>
                <div class="col-12">
                  <div class="row pb-4">
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Nombre</div> -->
                      <input
                        v-model.trim="signupForm.nombre"
                        type="text"
                        placeholder="Nombre*"
                        @input="
                          signupForm.nombre = $event.target.value.toUpperCase();
                          signupForm.nombre = quitarAcentos(signupForm.nombre);
                        "
                        required
                      />
                    </div>

                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Nombre</div> -->
                      <input
                        v-model.trim="signupForm.nombre_2"
                        type="text"
                        placeholder="Segundo Nombre"
                        @input="
                          signupForm.nombre_2 =
                            $event.target.value.toUpperCase();
                          signupForm.nombre_2 = quitarAcentos(
                            signupForm.nombre_2
                          );
                        "
                      />
                    </div>

                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.apellido_paterno"
                        type="text"
                        placeholder="Apellido Paterno*"
                        @input="
                          signupForm.apellido_paterno =
                            $event.target.value.toUpperCase();
                          signupForm.apellido_paterno = quitarAcentos(
                            signupForm.apellido_paterno
                          );
                        "
                        required
                      />
                    </div>
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.apellido_materno"
                        type="text"
                        placeholder="Apellido Materno"
                        @input="
                          signupForm.apellido_materno =
                            $event.target.value.toUpperCase();
                          signupForm.apellido_materno = quitarAcentos(
                            signupForm.apellido_materno
                          );
                        "
                      />
                    </div>
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.empresa"
                        type="text"
                        placeholder="Empresa"
                        @input="
                          signupForm.empresa =
                            $event.target.value.toUpperCase();
                          signupForm.empresa = quitarAcentos(
                            signupForm.empresa
                          );
                        "
                      />
                    </div>
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.puesto"
                        type="text"
                        placeholder="Puesto"
                        @input="
                          signupForm.puesto = $event.target.value.toUpperCase();
                          signupForm.puesto = quitarAcentos(signupForm.puesto);
                        "
                      />
                    </div>
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.email_user"
                        type="email"
                        placeholder="Correo Electrónico*"
                        @input="
                          signupForm.email_user =
                            $event.target.value.toLowerCase();
                          signupForm.email_user = quitarAcentos(
                            signupForm.email_user
                          );
                        "
                        required
                      />
                    </div>
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-9 pb-0">
                          <!-- <div class="blanco fG">Correo Electrónico</div> -->
                          <!-- <select v-model="signupForm.codigo_pais" required>
                          <option value="">Código País</option>

                          <option value="+52">MÉXICO +52</option>
                          <option value="+1">ESTADOS UNIDOS +1</option>
                          <option value="+1">CANADÁ +1</option>
                          <option value="+55">BRASIL +55</option>
                        </select> -->
                          <input
                            v-model.trim="signupForm.telefono"
                            type="number"
                            placeholder="Teléfono"
                            maxlength="10"
                          />
                        </div>

                        <div class="col-3 pb-0">
                          <input
                            v-model.trim="signupForm.ext"
                            type="number"
                            placeholder="Ext."
                            maxlength="10"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.movil"
                        type="number"
                        placeholder="Celular"
                        maxlength="10"
                      />
                    </div>
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="blanco fG">Apellido</div> -->
                      <input
                        v-model.trim="signupForm.anfitrion"
                        type="text"
                        placeholder="Anfitrión"
                        maxlength="250"
                        @input="
                          signupForm.anfitrion =
                            $event.target.value.toUpperCase();
                          signupForm.anfitrion = quitarAcentos(
                            signupForm.anfitrion
                          );
                        "
                      />
                    </div>
                    <div class="col-lg-12 pb-0">
                      <select
                        class="form-control negro"
                        name=""
                        id=""
                        v-model="signupForm.tipo"
                      >
                        <option value="">Tipo de Registro</option>
                        <option value="CLIENTE">CLIENTE</option>
                        <option value="CLIENTE TOP">CLIENTE TOP</option>
                        <option value="CLIENTE VIP">CLIENTE VIP</option>
                        <!-- <option value="SOCIO ESTRATEGICO">
                          SOCIO ESTRATEGICO
                        </option> -->
                        <option value="EQUIPO PROSA">EQUIPO PROSA</option>
                        <option value="STAFF COMM & RP">STAFF COMM & RP</option>
                        <option value="PATROCINIOS">PATROCINIOS</option>
                        <option value="MEDIOS">MEDIOS</option>
                        <option value="PONENTE">PONENTE</option>
                        <option value="STAFF AGENCIAS">STAFF AGENCIAS</option>
                        <option value="INVITADO">INVITADO</option>
                        <option value="EDCANES">EDECANES</option>
                        <!-- <option value="Talks 2 Code">
                                  Talks 2 Code
                                </option> -->
                      </select>
                    </div>
                  </div>

                  <div class="row pb-5">
                    <div class="col-12 text-center">
                      <button
                        type="submit"
                        class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                      >
                        Registrar Invitado
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-tab>

        <!-- <b-tab title="Sorteo" >
          <div class>
            <div class="col-12 negro pt-5 pb-3">
              <router-link class="btnaction" target="_blank" to="/administrador/sorteo">Abrir sorteo</router-link>
            </div>

            
          </div>
        </b-tab> -->
      </b-tabs>

      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
    </div>

    <!-- <Glyphicons></Glyphicons> -->

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 42;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SiteNav from "@/components/SiteNav2";


import * as moment from "moment";

import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    //Footer,
    SiteNav,
    // Glyphicons,
  },
  data() {
    return {
      reenvioForm: {
        codigo: "",
      },

      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        nombre: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
        anfitrion: "",
        tipo: "",
      },

      columnsRegistros: [
        "asistira_al_evento",
        "tipo",
        "codigo_qr",
        "nombre",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email",
        "telefono",
        "movil",
        "terminos",
        "asistio",
        "fecha_asistio",
        "email_operador",
        "timestamp",
      ],
      columnsInvitados: [
        "status",
        "registro_completado",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "tipo",
        "empresa",
        "puesto",
        "email",
        "telefono",
        "movil",
      ],
      columnsSolicitudes: [
        "no_cliente",
        "nombre",
        "apellido",
        "email",
        "estado",
        "FechaRegistro",
      ],
      data: null,
      options: {
        perPage: 100,
        headings: {
          tipo: "Tipo de registro",
          asistira_al_evento: "Asistirá al evento",
          email_operador: "Usuario que registró QR",
          cubrebocas: "Cubrebocas entregado",
          guantes: "Guantes entregado",
          kit_bienvenida: "Kit Bienvenida entregado",
          top: "Playera entregada",
          pulsera: "Pulsera entregada",
          asistio: "Asistió al evento",
          talla_tops: "Talla Playera",
          timestamp: "Fecha de registro en sistema",
        },
        editableColumns: [],
        sortable: [],
        texts: {
          count:
            "Mostrando {from} hasta {to} de {count} registros|{count} registros|Un registro",
          first: "Primero",
          last: "Último",
          filter: "Filtro:",
          filterPlaceholder: "Búsqueda",
          limit: "Registros:",
          page: "Página:",
          noResults: "No hay registros que concuerden",
          noRequest: "Please select at least one filter to fetch results",
          filterBy: "Filtrar por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },

      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: [],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      centros: [],
      registros: [],
      invitados: [],
      user: null,
      contador_clinica: 0,
      contador_torneo: 0,
      contador_comida: 0,

      tope_clientes_todos: 850,
      tope_equipo_prosa: 80,
      tope_staff_rp: 8,
      tope_patrocinios: 152,
      tope_medios: 20,
      tope_talks_2_code: 3,
      tope_ponentes: 29,
      tope_staff_agencias: 11,
      tope_acompanantes: 50,
      tope_edecanes: 50,

      clientes_todos: 0,
      clientes: 0,
      clientes_top: 0,
      clientes_vip: 0,

      clientes_todos_si: 0,
      clientes_todos_no: 0,
      clientes_todos_pendiente: 0,
      clientes_todos_asistiendo: 0,

      clientes_si: 0,
      clientes_no: 0,
      clientes_pendiente: 0,
      clientes_asistiendo: 0,

      clientes_top_si: 0,
      clientes_top_no: 0,
      clientes_top_pendiente: 0,
      clientes_top_asistiendo: 0,

      clientes_vip_si: 0,
      clientes_vip_no: 0,
      clientes_vip_pendiente: 0,
      clientes_vip_asistiendo: 0,

      equipo_prosa: 0,
      staff_rp: 0,
      patrocinios: 0,
      medios: 0,
      talks_2_code: 0,
      ponentes: 0,
      staff_agencias: 0,
      acompanantes: 0,
      edecanes: 0,
      


      equipo_prosa_si: 0,
      equipo_prosa_no: 0,
      equipo_prosa_pendiente: 0,
      equipo_prosa_asistiendo: 0,

      staff_rp_si: 0,
      staff_rp_no: 0,
      staff_rp_pendiente: 0,
      staff_rp_asistiendo: 0,

      patrocinios_si: 0,
      patrocinios_no: 0,
      patrocinios_pendiente: 0,
      patrocinios_asistiendo: 0,

      medios_si: 0,
      medios_no: 0,
      medios_pendiente: 0,
      medios_asistiendo: 0,

      talks_2_code_si: 0,
      talks_2_code_no: 0,
      talks_2_code_pendiente: 0,
      talks_2_code_asistiendo: 0,

      ponentes_si: 0,
      ponentes_no: 0,
      ponentes_pendiente: 0,
      ponentes_asistiendo: 0,

      staff_agencias_si: 0,
      staff_agencias_no: 0,
      staff_agencias_pendiente: 0,
      staff_agencias_asistiendo: 0,

      acompanantes_si: 0,
      acompanantes_no: 0,
      acompanantes_pendiente: 0,
      acompanantes_asistiendo: 0,

      edecanes_si: 0,
      edecanes_no: 0,
      edecanes_pendiente: 0,
      edecanes_asistiendo: 0,

      sin_clasificar: 0,

      no_asistentes: 0,

      filtro_asistencia: '',
      filtro_asistencia_invitados: ''


    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.user = JSON.parse(localStorage.getItem("user_foroprosa_2023"));

    this.getRegistros();
  },
  methods: {
    filtrarAsistencia(e){
      this.getRegistros();
    },
    filtrarAsistenciaInvitados(e){
      this.getInvitados();
    },
    cancelarRegistro(id, nombre, apellido_paterno) {
      swal
        .fire({
          title: "Cancelar Registro",
          html:
            "¿Estás seguro de querer cancelar el registro de " +
            nombre +
            " " +
            apellido_paterno +
            "?",
          icon: "warning",
          confirmButtonText: "Ok",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            //
            this.confirmarCancelarRegistro(id);
          }
        });
    },
    confirmarCancelarRegistro(id) {
      this.$store.dispatch("showLoader", true);

      var qData = {
        id: id,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "cancelarRegistro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            window.location.reload();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },

    cancelarInvitacion(email, nombre, apellido_paterno, status) {
      swal
        .fire({
          title: "Cambiar estatus",
          html:
            "¿Estás seguro de querer cambiar el estatus de la invitación de " +
            nombre +
            " " +
            apellido_paterno +
            "?",
          icon: "warning",
          confirmButtonText: "Ok",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            //
            this.confirmarCancelarInvitacion(email, status);
          }
        });
    },
    confirmarCancelarInvitacion(email, status) {
      this.$store.dispatch("showLoader", true);

      var qData = {
        email: email,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "cambioEstatusInvitacion.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);

            this.getInvitados();
            //window.location.reload();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },

    descargarQR(e, codigo_qr, imgurl) {
      var a = document.createElement("a");
      a.href = imgurl;
      a.download = "Foro Prosa QR - " + codigo_qr + ".png";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      console.log("descargando imagen");
      //       e.preventDefault(); // Prevent browser's default download stuff...
      //       var a = $("<a>")
      //     .attr("href", img)
      //     .attr("download", "Foro Prosa QR - " + codigo_qr + ".png")
      //     .appendTo("body");
      //     a[0].click();
      //     a.remove();
    },
    quitarAcentos(elemento) {
      //console.log('quitando acentos')
      elemento = elemento.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      //console.log({elemento})
      return elemento;
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    async changeStatusAsistenciaEvento(nombre, email, codigo_qr, status) {
      console.log({ changeStatusCodigo: codigo_qr });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        nombre: nombre,
        email: email,
        codigo_qr: codigo_qr,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusAsistenciaEvento.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async validarInvitacion(email) {
      console.log({ reenviarinvitacion: email });

      this.$store.dispatch("showLoader", true);

      var qData = {
        email: email,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "validarInvitacion.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res reenvio");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              swal.fire("Bien", res.msg, "success");

              this.getInvitados();
            } else {
              swal.fire(
                "Oops",
                "Hubo un problema al momento de reenviar la invitación, por favor intenta de nuevo.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async reenviarInvitacion(email) {
      console.log({ reenviarinvitacion: email });

      this.$store.dispatch("showLoader", true);

      var qData = {
        email: email,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvioInvitacion.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res reenvio");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire(
                "Oops",
                "Hubo un problema al momento de reenviar la invitación, por favor intenta de nuevo.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async reenviarInvitacionQR(id) {
      console.log({ reenviarinvitacionqr: id });

      this.$store.dispatch("showLoader", true);

      var qData = {
        id: id,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res reenvio");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire(
                "Oops",
                "Hubo un problema al momento de reenviar el código QR, por favor intenta de nuevo.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTipoRegistro(id, email, status) {
      console.log({ changeStatusTipoRegistro: id });

      //revisar el tope antes de continuar
      if (status != "") {
        let temp_count = 0;
        let temp_tope = 0;
        switch (status) {
          case "CLIENTE":
            temp_count = this.clientes_todos;
            temp_tope = this.tope_clientes_todos;
            break;
          case "CLIENTE TOP":
            temp_count = this.clientes_todos;
            temp_tope = this.tope_clientes_todos;
            break;
          case "CLIENTE VIP":
            temp_count = this.clientes_todos;
            temp_tope = this.tope_clientes_todos;
            break;
          case "EQUIPO PROSA":
            temp_count = this.equipo_prosa;
            temp_tope = this.tope_equipo_prosa;
            break;
          case "STAFF COMM & RP":
            temp_count = this.staff_rp;
            temp_tope = this.tope_staff_rp;
            break;
          case "STAFF AGENCIAS":
            temp_count = this.staff_agencias;
            temp_tope = this.tope_staff_agencias;
            break;
          case "INVITADO":
            temp_count = this.acompanantes;
            temp_tope = this.tope_acompanantes;
            break;
          case "EDECANES":
            temp_count = this.edecanes;
            temp_tope = this.tope_edecanes;
            break;
          case "PATROCINIOS":
            temp_count = this.patrocinios;
            temp_tope = this.tope_patrocinios;
            break;
          case "MEDIOS":
            temp_count = this.medios;
            temp_tope = this.tope_medios;
            break;
          case "PONENTE":
            temp_count = this.ponentes;
            temp_tope = this.tope_ponentes;
            break;
        }

        if (temp_count >= temp_tope) {
          swal.fire(
            "Operación no realizada",
            "Se ha llegado al tope máximo para este tipo de registro.",
            "warning"
          );

          return;
        }
      }

      this.$store.dispatch("showLoader", true);

      var qData = {
        id: id,
        email: email,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTipoRegistro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res reenvio");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              swal.fire("Bien", res.msg, "success");

              for (var i = 0; i < this.registros.length; i++) {
                if (this.registros[i].id === id) {
                  this.registros[i].tipo = status;
                }
              }

              this.cuentaRegistros();
            } else {
              swal.fire(
                "Oops",
                "Hubo un problema al momento de intentar actualizar el tipo de registro, intenta más tarde.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusComida(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusComida.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTorneo(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTorneo.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusClinica(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusClinica.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTalla(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTalla.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusGuantes(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusGuantes.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusHorarioClinica(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusHorarioClinica.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusCubrebocas(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusCubrebocas.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    getInvitados() {
      console.log("get invitados");

      const https = require("https");
      var qData = {
        // id: this.user.no_cliente,
        asistira_al_evento: this.filtro_asistencia_invitados
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getInvitados.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.invitados = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    getRegistros() {
      console.log("get registros");

      const https = require("https");
      var qData = {
        no_cliente: this.user.no_cliente,
        asistira_al_evento: this.filtro_asistencia
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistros.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registros = res.datos;

              this.cuentaRegistros();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    cuentaRegistros() {
      this.clientes_todos = 0;
      this.clientes = 0;
      this.clientes_vip = 0;
      this.clientes_top = 0;

      this.equipo_prosa = 0;
      this.staff_rp = 0;
      this.staff_agencias = 0;
      this.acompanantes = 0;
      this.edecanes = 0;
      this.patrocinios = 0;
      this.medios = 0;
      this.talks_2_code = 0;
      this.ponentes = 0;

      this.clientes_todos_si = 0;
      this.clientes_todos_no = 0;
      this.clientes_todos_pendiente = 0;
      this.clientes_todos_asistiendo = 0;

      this.clientes_si = 0;
      this.clientes_no = 0;
      this.clientes_pendiente = 0;
      this.clientes_asistiendo = 0;

      this.clientes_top_si = 0;
      this.clientes_top_no = 0;
      this.clientes_top_pendiente = 0;
      this.clientes_top_asistiendo = 0;

      this.clientes_vip_si = 0;
      this.clientes_vip_no = 0;
      this.clientes_vip_pendiente = 0;
      this.clientes_vip_asistiendo = 0;

      this.equipo_prosa_si = 0;
      this.equipo_prosa_no = 0;
      this.equipo_prosa_pendiente = 0;
      this.equipo_prosa_asistiendo = 0;

      this.staff_rp_si = 0;
      this.staff_rp_no = 0;
      this.staff_rp_pendiente = 0;
      this.staff_rp_asistiendo = 0;

      this.patrocinios_si = 0;
      this.patrocinios_no = 0;
      this.patrocinios_pendiente = 0;
      this.patrocinios_asistiendo = 0;

      this.medios_si = 0;
      this.medios_no = 0;
      this.medios_pendiente = 0;
      this.medios_asistiendo = 0;

      this.talks_2_code_si = 0;
      this.talks_2_code_no = 0;
      this.talks_2_code_pendiente = 0;
      this.talks_2_code_asistiendo = 0;

      this.ponentes_si = 0;
      this.ponentes_no = 0;
      this.ponentes_pendiente = 0;
      this.ponentes_asistiendo = 0;

      this.staff_agencias_si = 0;
      this.staff_agencias_no = 0;
      this.staff_agencias_pendiente = 0;
      this.staff_agencias_asistiendo = 0;

      this.acompanantes_si = 0;
      this.acompanantes_no = 0;
      this.acompanantes_pendiente = 0;
      this.acompanantes_asistiendo = 0;

      this.edecanes_si = 0;
      this.edecanes_no = 0;
      this.edecanes_pendiente = 0;
      this.edecanes_asistiendo = 0;

      this.sin_clasificar = 0;

      this.no_asistentes = 0;



      for (var i = 0; i < this.registros.length; i++) {
        if (this.registros[i].tipo == "CLIENTE") {
          
          
          this.clientes_todos++;
          this.clientes++;

         

          if(this.registros[i].asistira_al_evento == "SI"){
            this.clientes_si++;
            this.clientes_todos_si++;
          }else if(this.registros[i].asistira_al_evento == "NO"){
            this.clientes_no++;
            this.clientes_todos_no++;
          }else if(this.registros[i].asistira_al_evento == "PENDIENTE"){
            this.clientes_pendiente++;
            this.clientes_todos_pendiente++;
          } 

          if(this.registros[i].asistio == 1){
            this.clientes_asistiendo++;
            this.clientes_todos_asistiendo++;
          }

        }

        if (this.registros[i].tipo == "CLIENTE TOP") {
          
          
          this.clientes_todos++;
          this.clientes_top++;

        

          if(this.registros[i].asistira_al_evento == "SI"){
            this.clientes_top_si++;
            this.clientes_todos_si++;
          }else if(this.registros[i].asistira_al_evento == "NO"){
            this.clientes_top_no++;
            this.clientes_todos_no++;
          }else if(this.registros[i].asistira_al_evento == "PENDIENTE"){
            this.clientes_top_pendiente++;
            this.clientes_todos_pendiente++;
          } 


          if(this.registros[i].asistio == 1){
            this.clientes_top_asistiendo++;
            this.clientes_todos_asistiendo++;
          }

        }
        if (this.registros[i].tipo == "CLIENTE VIP") {
         
          this.clientes_todos++;
          this.clientes_vip++;

          

          if(this.registros[i].asistira_al_evento == "SI"){
            this.clientes_vip_si++;
            this.clientes_todos_si++;
          }else if(this.registros[i].asistira_al_evento == "NO"){
            this.clientes_vip_no++;
            this.clientes_todos_no++;
          }else if(this.registros[i].asistira_al_evento == "PENDIENTE"){
            this.clientes_vip_pendiente++;
            this.clientes_todos_pendiente++;
          } 


          if(this.registros[i].asistio == 1){
            this.clientes_vip_asistiendo++;
            this.clientes_todos_asistiendo++;
          }


        }
        if (this.registros[i].tipo == "EQUIPO PROSA") {
          this.equipo_prosa++;

          if(this.registros[i].asistira_al_evento == "SI"){
            this.equipo_prosa_si++;
          }else if(this.registros[i].asistira_al_evento == "NO"){
            this.equipo_prosa_no++;
          }else if(this.registros[i].asistira_al_evento == "PENDIENTE"){
            this.equipo_prosa_pendiente++;
          } 

          if(this.registros[i].asistio == 1){
            this.equipo_prosa_asistiendo++;
          }


        }
        if (this.registros[i].tipo == "STAFF COMM & RP") {
          this.staff_rp++;

          if(this.registros[i].asistira_al_evento == "SI"){
            this.staff_rp_si++;
          }else if(this.registros[i].asistira_al_evento == "NO"){
            this.staff_rp_no++;
          }else if(this.registros[i].asistira_al_evento == "PENDIENTE"){
            this.staff_rp_pendiente++;
          } 

          if(this.registros[i].asistio == 1){
            this.staff_rp_asistiendo++;
          }
        }

        if (this.registros[i].tipo == "STAFF AGENCIAS") {
          this.staff_agencias++;

          if(this.registros[i].asistira_al_evento == "SI"){
            this.staff_agencias_si++;
          }else if(this.registros[i].asistira_al_evento == "NO"){
            this.staff_agencias_no++;
          }else if(this.registros[i].asistira_al_evento == "PENDIENTE"){
            this.staff_agencias_pendiente++;
          } 

          if(this.registros[i].asistio == 1){
            this.staff_agencias_asistiendo++;
          }

        }

        if (this.registros[i].tipo == "INVITADO") {
          this.acompanantes++;

          if(this.registros[i].asistira_al_evento == "SI"){
            this.acompanantes_si++;
          }else if(this.registros[i].asistira_al_evento == "NO"){
            this.acompanantes_no++;
          }else if(this.registros[i].asistira_al_evento == "PENDIENTE"){
            this.acompanantes_pendiente++;
          } 

          if(this.registros[i].asistio == 1){
            this.acompanantes_asistiendo++;
          }

        }

        if (this.registros[i].tipo == "EDECANES") {
          this.edecanes++;

          if(this.registros[i].asistira_al_evento == "SI"){
            this.edecanes_si++;
          }else if(this.registros[i].asistira_al_evento == "NO"){
            this.edecanes_no++;
          }else if(this.registros[i].asistira_al_evento == "PENDIENTE"){
            this.edecanes_pendiente++;
          } 

          if(this.registros[i].asistio == 1){
            this.edecanes_asistiendo++;
          }

        }

        if (this.registros[i].tipo == "PATROCINIOS") {
          this.patrocinios++;

          if(this.registros[i].asistira_al_evento == "SI"){
            this.patrocinios_si++;
          }else if(this.registros[i].asistira_al_evento == "NO"){
            this.patrocinios_no++;
          }else if(this.registros[i].asistira_al_evento == "PENDIENTE"){
            this.patrocinios_pendiente++;
          } 

          if(this.registros[i].asistio == 1){
            this.patrocinios_asistiendo++;
          }
        }
        if (this.registros[i].tipo == "MEDIOS") {
          this.medios++;

          if(this.registros[i].asistira_al_evento == "SI"){
            this.medios_si++;
          }else if(this.registros[i].asistira_al_evento == "NO"){
            this.medios_no++;
          }else if(this.registros[i].asistira_al_evento == "PENDIENTE"){
            this.medios_pendiente++;
          } 

          if(this.registros[i].asistio == 1){
            this.medios_asistiendo++;
          }
        }
        if (this.registros[i].tipo == "PONENTE") {
          this.ponentes++;

          if(this.registros[i].asistira_al_evento == "SI"){
            this.ponentes_si++;
          }else if(this.registros[i].asistira_al_evento == "NO"){
            this.ponentes_no++;
          }else if(this.registros[i].asistira_al_evento == "PENDIENTE"){
            this.ponentes_pendiente++;
          } 

          if(this.registros[i].asistio == 1){
            this.ponentes_asistiendo++;
          }
        }

        if (this.registros[i].tipo == "") {
          this.sin_clasificar++;
        }

        if (this.registros[i].asistio == 1) {
          this.no_asistentes++;
        }


      }
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              //this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1;
              this.signupForm.nombre_2 = res.datos[0].nombre_2;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              this.reenvioForm.codigo = "";

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registroXAdmin.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signupInvitado(e) {
      e.preventDefault();
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");

      if (this.user.nombre == "Admin") {
        this.signupForm.status = "VALIDO";
      } else {
        this.signupForm.status = "POR VALIDAR";
      }

      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registroInvitadoXAdmin.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.talla_cubrebocas = "";
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.horario_clinica = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_guantes = "";
      }
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
        anfitrion: "",
        tipo: "",
      };
    },
  },
};
</script>

